import React, { useState } from 'react'


const Admin = () => {
  let [data,setData]=useState('')


  let getVal = (e)=>{
    console.log(e.target.value)
    setData(e.target.value)
  }
  
  return (
    <>
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h1>Input Data</h1>
              </div>
              <div className="card-body">
                <form>
                  <div className="mb-3 mt-3">
                    <label htmlFor="name" className="form-label">Name: {data}</label>
                    <input type="text" className="form-control" id="name" placeholder="Enter enter Name" name="name" onChange={getVal}/>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Admin
